import { ReactElement } from 'react';
import { styled } from 'styled-components';
import SearchForm from './SearchForm';
import Table from './Table';
import useCustomers from '../hooks/useCustomers';
import { blockStyle } from '../../../../components/styles/Block';
import layoutStyle from '../../../../components/styles/Layout';

const ContentBlock = styled.div`
  ${blockStyle}
`;

const ContentLayout = styled.div`
  ${layoutStyle}
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 16px;
`;

const Content = (): ReactElement => {
  const { customers, total, page, pageSize, setPage, searchValues, handleSearch, handleClear } = useCustomers();

  return (
    <ContentBlock>
      <ContentLayout>
        <SearchForm initialValues={searchValues} onSearch={handleSearch} onClear={handleClear} />
        <Table data={customers} page={page} pageSize={pageSize} total={total} onPageChange={setPage} />
      </ContentLayout>
    </ContentBlock>
  );
};

export default Content;
